import React from "react";
import {Helmet} from "react-helmet";
import {MichaelIsles} from "../../constants/meta";

export const A33Meta = () => (
    <Helmet>
        <title>Josh Bowe | Vieunite </title>
        <meta name="twitter:card" value="summary"/>
        <meta name="twitter:site" value="@VieuniteHQ"/>
        <meta name="twitter:title" value="Vieunite Artist | Josh Bowe"/>
        <meta name="twitter:description"
              content=". This proposal celebrates his distinctive visual language, offering audiences a reflective encounter with selfhood, transformation, and the complex beauty of being both whole and fragmented. "/>
        <meta name="twitter:url" value="https://vieunite.com/artists/josh-bowe"/>
        <meta name="twitter:image" value="https://vieunite.com/images/vieunite_sc_josh_bowe.jpg"/>

        <meta property="og:url" content="https://vieunite.com/artists/josh-bowe"/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content="Vieunite Artist | Josh Bowe"/>
        <meta property="og:description"
              content=" This proposal celebrates his distinctive visual language, offering audiences a reflective encounter with selfhood, transformation, and the complex beauty of being both whole and fragmented. "/>
        <meta property="og:image" content="https://vieunite.com/images/vieunite_sc_ josh_bowe.jpg"/>


    </Helmet>);